import { faCircleExclamation, faSearch } from '@fortawesome/pro-regular-svg-icons';
import { useIntl } from 'react-intl';

import { parkingManagementMessages } from 'src/features/parkingManagement/utils';
import { GeneralBlock } from 'src/registry/components/blocks/GeneralBlock';
import GeneralMessageBlock from 'src/registry/components/blocks/GeneralMessageBlock';
import { tableMessages } from 'src/registry/components/table';

type EmptyStateProps<T> = {
    isLoading: boolean;
    isError: boolean;
    parkingName?: string;
    data: T;
};

const EmptyState = <T,>({ isLoading, isError, data, parkingName }: EmptyStateProps<T>) => {
    const { formatMessage } = useIntl();

    return (
        <>
            {!data && !isLoading && !isError && (
                <>
                    <GeneralBlock className="h-96 border-none shadow-none">
                        <GeneralMessageBlock
                            icon={faSearch}
                            title={formatMessage(tableMessages.noResults)}
                            subtitle={formatMessage(parkingManagementMessages.noResultsDescription, {
                                section: formatMessage(parkingManagementMessages.zones),
                                parkingName: parkingName,
                            })}
                        />
                    </GeneralBlock>
                </>
            )}
            {isError && (
                <GeneralBlock className="h-96 border-none shadow-none">
                    <GeneralMessageBlock variant="error" icon={faCircleExclamation} />
                </GeneralBlock>
            )}
        </>
    );
};

export default EmptyState;
